<template>
  <span class="loader-cache"></span>
</template>

<script>
export default {
  name: "LoaderLine"
}
</script>

<style scoped lang="scss">
  .loader-cache {
    position: absolute;
    width: 100%;
    height: 4.8px;
    display: inline-block;
    top: 0;
    left: 0;
    background: var(--color-dark-green);
    overflow: hidden;
    z-index: 999;
  }
  .loader-cache::after {
    content: '';
    width: 192px;
    height: 4.8px;
    background: var(--color-grey);
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    animation: animloader 2s linear infinite;
  }

  @keyframes animloader {
    0% {
      left: 0;
      transform: translateX(-100%);
    }
    100% {
      left: 100%;
      transform: translateX(0%);
    }
  }
</style>